// Each entry in this array must be exactly 10x larger than the one before it
const metricUnits = ["mm", "cm", "dm", "m"];
const meterPerInch = 0.0254;
const inchPerFeet = 12;
const meterPerFeet = meterPerInch * inchPerFeet;
export const isEqualLength = (l, r) => l.length === convertLength(r.length, r.unit, l.unit);
/**
 * Converts string to LengthUnit.
 * @throws an error if the supplied string isn't a known length unit
 */
export function toLengthUnit(unit) {
    // The list below must EXACTLY match isLengthUnit(string)
    unit = unit === null || unit === void 0 ? void 0 : unit.toLowerCase();
    if (unit === "inch") {
        unit = "in";
    }
    if (unit === "in" ||
        unit === "ft" ||
        unit === "mm" ||
        unit === "cm" ||
        unit === "dm" ||
        unit === "m") {
        return unit;
    }
    throw new Error(`Unknown length unit ${unit}`);
}
/**
 * As we accept inch as an alias for in we can't make this a typeguard
 */
export function isLengthUnit(unit) {
    // The list below must EXACTLY match toLengthUnit(string)
    unit = unit === null || unit === void 0 ? void 0 : unit.toLowerCase();
    return (unit === "inch" ||
        unit === "in" ||
        unit === "ft" ||
        unit === "mm" ||
        unit === "cm" ||
        unit === "dm" ||
        unit === "m");
}
export function convertLength(l, from, to) {
    if (from === to) {
        return l;
    }
    if (from === "ft" && to === "in") {
        return l * inchPerFeet;
    }
    if (from === "in" && to === "ft") {
        return l / inchPerFeet;
    }
    if (from === "ft") {
        l *= meterPerFeet;
        from = "m";
    }
    else if (from === "in") {
        l *= meterPerInch;
        from = "m";
    }
    if (to === "ft") {
        l /= meterPerFeet;
        to = "m";
    }
    else if (to === "in") {
        l /= meterPerInch;
        to = "m";
    }
    if (from === to) {
        return l;
    }
    l *= Math.pow(10, metricUnits.indexOf(from) - metricUnits.indexOf(to));
    return l;
}
